import React, { useState, useEffect, Fragment } from "react";
import { Link, useParams } from "react-router-dom";

// import Card from "../../UI/Card";
import { Card } from "@mui/material";

import "./oppositeDefine.css";
import ProgramsSerivce from "../../../../../redux/services/categories/Programs/programs";
import VerbsService from "../../../../../redux/services/categories/verbs/programs";
import OppositeServices from "../../../../../redux/services/categories/opposite/programs";

const OppositeDefine = () => {
  const [category, setCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const sub = OppositeServices.define("oppositechoose").then((res) => {
      setCategory(res.data.opposites);
      setIsLoading(false)
    });
  }, []);

  
  if (isLoading) return <></>;
  return (
    <section className="learning__program__secttion">
      <Card>
        <div className="learning__container">
          {category.map((t) => {
            // //console.log(t);
            // return <></>;
            return (
              <Fragment key={t.id}>
                <Link
                  className="program__details__btn"
                  to={`/programs/opposite/define/${t.id}`}
                >
                  {t.name}
                </Link>
              </Fragment>
            );
          })}
        </div>
      </Card>
    </section>
  );
};

export default OppositeDefine;
